import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const VenueHighlights = ({ id }) => {
  const [venueHighlights, setVenueHighlights] = useState([]);
  const [selectedHighlights, setSelectedHighlights] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      $(".highlightsModel").click(function () {
        const highlightsId = $(this).data("id");
        const highlights = venueHighlights.find(
          (v) => v.venueHighlightsID == highlightsId
        );
        if (highlights) {
          setSelectedHighlights(highlights);
          setIsModalOpen(true);
        }
      });
    }, 1000);
  }, [venueHighlights]);
  const fetchData = async () => {
    try {
      const response = await corefetch(
        `VenueHighlights/GetVenueHighlightsDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedHighlights = response.map((highlight) => ({
          ...highlight,
          image: `${ImageURL}${highlight.imagePath}`,
        }));
        setVenueHighlights(mappedHighlights);
      } else {
        setVenueHighlights([]);

        console.log("No venue highlights found");
      }
    } catch (error) {
      setVenueHighlights([]);
      console.error("Error fetching venue highlights:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (venueHighlights?.length) {
      const $carousel = $(".VenueHighlights-slider");
      if ($carousel.hasClass("owl-loaded")) {
        $carousel.trigger("destroy.owl.carousel");
        $carousel.html($carousel.find(".owl-stage-outer").html()); // Remove extra wrappers
      }

      $carousel.owlCarousel({
        autoplay: true,
        smartSpeed: 100,
        margin: 30,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        center: true,
        items: 4,
        stagePadding: 60,
        navText: [
          '<i class="ti-arrow-left"></i>',
          '<i class="ti-arrow-right"></i>',
        ],
        responsive: {
          0: {
            items: 1,
            stagePadding: 5,
          },
          575: {
            items: 1,
            stagePadding: 5,
          },
          767: {
            items: 2,
          },
          992: {
            items: 2,
          },
          1200: {
            items: 4,
          },
        },
      });
    }
  }, [venueHighlights]);

  const openModal = (highlight) => {
    setSelectedHighlights(highlight);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedHighlights(null);
    setIsModalOpen(false);
  };

  if (!venueHighlights || venueHighlights.length === 0) {
    return null;
  }

  return (
    <>
      <section className="wpo-Service-section-s2 section-padding highlights">
        <h2 className="hidden">Venue Highlights</h2>
        <div className="container-fluid">
          <div className="wpo-section-title">
            <h4>Venue Highlights</h4>
            <div className="shape-2 wow fadeInUp animated">
              <img src="assets/images/Wedding/shape6.png" alt="" />
            </div>
          </div>
          <div className="wpo-Service-wrap">
            <div className="VenueHighlights-slider owl-carousel ">
              {venueHighlights?.map((highlight) => (
                <div
                  key={highlight.venueHighlightsID}
                  data-id={highlight.venueHighlightsID}
                  className="wpo-Service-item highlights highlightsModel"
                >
                  <div className="wpo-Service-img highlights">
                    <img
                      className="venueImg"
                      src={highlight.image}
                      alt={highlight.venueHighlightsType}
                      onClick={() => openModal(highlight)}
                    />
                  </div>
                  {/* <div className="wpo-Service-text">
                    <a
                      className="venue highlights"
                      href="#"
                      onClick={() => openModal(highlight)}
                    >
                      {highlight.venueHighlightsType}
                    </a>
                  </div> */}
                  <div className="wpo-Service-text" style={{ margin: 0 }}>
                    <a
                      className="venue highlights"
                      // href="#"
                      onClick={() => openModal(highlight)}
                    >
                      {highlight.venueHighlightsType}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isModalOpen && selectedHighlights && (
        <div id="ServiceModal" className="popup">
          <div className="modal-content venueHighlights">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">
              {selectedHighlights.venueHighlightsType}
            </div>
            <div className="additional-text">
              <p>{selectedHighlights.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VenueHighlights;
